import crypto from 'crypto';

export default function getEncryptedApiKey(privateKey = null) {
  privateKey = privateKey || process.env.VUE_APP_API_PRIVATE;
  const timestamp = Math.floor(Date.now() / 1000);
  const apiPrivate = crypto.createHmac('sha256', privateKey).update(btoa(timestamp)).digest('base64');
  return btoa(`${timestamp}.${apiPrivate}`);
}
